import { IconButton } from '@mui/material';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { containerPaddingPx } from './DialogStyledComponents';
import { useTracking } from '../tracking';

const DialogTitleContentDiv = styled.div`
  padding: 14px ${containerPaddingPx}px;
  margin: 0;
  font-weight: 500;
  line-height: 28px;
  border-bottom: 1px solid #dce4e8;

  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  font-size: 22px;

  .main-header-content {
    flex-grow: 1;
  }
`;

interface Action {
  title: string;
  icon: React.ReactElement;
  callback: () => unknown;
}

const renderAction = (
  action: Action,
  generateTrackingProps: (actionName: string) => Record<string, any>
) => (
  <IconButton
    aria-label={action.title}
    onClick={action.callback}
    {...generateTrackingProps(`${action.title}-button`)}
  >
    {action.icon}
  </IconButton>
);

export const DialogHeader = (props: {
  prefixAction?: Action;
  prefixIcon?: ReactNode;
  children: ReactNode;
  postfixActions?: Action[];
  postfixAction?: Action;
}) => {
  const { generateTrackingProps } = useTracking();
  const { prefixAction, children, postfixActions, postfixAction } = props;

  return (
    <DialogTitleContentDiv>
      <span className="prefixActions">
        {prefixAction && renderAction(prefixAction, generateTrackingProps)}
      </span>
      <span className="main-header-content">{children}</span>
      <span className="postfixActions">
        {postfixAction && renderAction(postfixAction, generateTrackingProps)}
        {postfixActions?.map(action =>
          renderAction(action, generateTrackingProps)
        )}
      </span>
    </DialogTitleContentDiv>
  );
};
